module.exports = __webpack_public_path__ + "img/gps_ios_kakao.cc28e5f0.jpg";